import React from 'react';
import RCANextSteps from './RCANextSteps';
import CarListItem from './car/CarListItem';
import CarListNew from './car/CarListNew';
import Row from 'react-bootstrap/Row';
import rcastyles from '../../styles/rca/RCASearch.module.scss';

const RCAVehiclesList  = (props) => {

    const {vehicles, editStep, setActiveVehicle} = props;
    const nextSteps = ['Proprietar', 'Adresa', 'Conducatori auto'];
   
    return (
        <>
            <section className={`${rcastyles.boxWrapper} p-3 mb-3`}>
                <h2 className="heading2">Alege un autovehicul</h2>
                <Row>
                    {vehicles.map( (item, i) =>
                        <CarListItem
                            key={i}
                            car={item.car}
                            editStep={editStep}
                            setActiveVehicle={setActiveVehicle}
                            id={i}
                        />
                    )}
                    <CarListNew 
                        editStep={editStep}
                    />
                </Row>
            </section>
            {/* <RCANextSteps steps={nextSteps} /> */}
        </>
    );
}

export default RCAVehiclesList;